import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';

import { disclaimer } from './constants';
import { submitInquiries } from '../../services';
import styles from './styles.module.css';
import ContactForm from './ContactForm';
import MainForm from './MainForm';

const InquiriesForm = ({ location }) => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const history = useHistory();
  const [captcha, setCaptcha] = useState(true);
  const onChange = (value) => {
    setCaptcha(true);
  };
  const onSubmit = (data) => {
    const payload = {
      lead_source: 'Web-To-Lead Form',
      oid: '00D36000000u0it',
      retURL: 'https://fabfitfun.com/get-the-box/',
      captcha_settings: {
        keyname: 'fabfitfunWebLead',
        fallback: true,
        orgId: '00D36000000u0it',
        ts: '',
      },
      ...data,
    };
    if (captcha) {
      submitInquiries(payload).then((response) => {
        history.push('/my-account');
      });
    }
  };
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={styles['inquiries-form']}
    >
      <MainForm register={register} errors={errors} />
      <ContactForm register={register} errors={errors} />
      <ReCAPTCHA
        sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
        onChange={onChange}
      />
      <br />
      <input type="submit" />
      <p><small>{disclaimer}</small></p>
    </form>
  );
};

export default InquiriesForm;
